import { render, staticRenderFns } from "./document-viewer.vue?vue&type=template&id=5d974e53&"
import script from "./document-viewer.vue?vue&type=script&lang=ts&"
export * from "./document-viewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports